import { observer } from 'mobx-react';
import { SearchBar } from '../shared/search-bar';
import { Page } from '../shared/page';
import { OnePaneLayout } from '../shared/layouts';
import { PageActions } from '../shared/page-actions';
import { VideoGuidesTable } from './video-guides-table';
import { Link } from 'react-router-dom';
import { Auth } from '@masala-lib/editorial/db/auth';
import { VideoGuideManager } from '@masala-lib/catalog/db/video-guide-manager';

export const VideoGuidesListScreen = observer(() => {
  const auth = Auth.getInstance();
  const manager = VideoGuideManager.getInstance();
  const list = manager.list;

  return (
    <Page
      title="Manage Video Guides"
      controls={
        <PageActions>
          {auth.isAdmin ? (
            <Link to={'/video-guides/new'} className="primary-action">
              Create new Video guide
            </Link>
          ) : null}
          <SearchBar manager={manager} />
        </PageActions>
      }
    >
      <OnePaneLayout>
        <VideoGuidesTable list={list} />
      </OnePaneLayout>
    </Page>
  );
});
